// Api.
import api from '../Base';

// Types.
import HostDisk from '../../types/host/HostDisk';
import { showError } from '../../utils/showAlert';

const DiskApi = {

    // Disk volumes, optionally restricted to specific hosts. Sorted by name.
    getDisks: async (hostIds?: number[]): Promise<HostDisk[]> => {
        const idParams = hostIds && hostIds.length > 0
            ? '&' + hostIds.map(id => `hostid=${id}`).join('&')
            : '';
        const url = `disk?sort=name${idParams}`;

        let disks: HostDisk[] = [];

        await api.get<HostDisk[]>(url)
            .then((response) => {
                disks = response.data;
            })
            .catch((error: any) => {
                console.error('Failed to retrieve disks.', error);
                showError('Failed to retrieve disks', error.message || error.toString());
            });

        return disks;
    },

    // Time series for one disk volume. Every collected metric comes back as a named
    // field on each row, the same shape as the v2 host statistic rows. Errors are left
    // to the caller: the alert rule preview fires this per (host, disk) pair and counts
    // its own failures rather than raising a global alert for each one.
    getDiskStatisticTime: async (
        timeRangeQueryString: string,
        hostId: number,
        disk: string
    ): Promise<any[]> => {
        const url = `disk/statistic/time?${timeRangeQueryString}&limit=${process.env.REACT_APP_API_LIMIT}&id=${hostId}&disk=${encodeURIComponent(disk)}`;
        const response = await api.get<any[]>(url);

        return response.data || [];
    },

    // Disk statistic metric types, including units and aggregation (same shape
    // as host/instance statistic types).
    getDiskStatisticTypes: async (): Promise<any[]> => {
        let types: any[] = [];

        await api.get<any[]>(`disk/statistic/type?collect=true`)
            .then((response) => {
                types = response.data;
            })
            .catch((error: any) => {
                console.error('Failed to retrieve disk statistic types.', error);
                showError('Failed to retrieve disk statistic types', error.message || error.toString());
            });

        return types;
    },
};

export default DiskApi;
